// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__mvuM9","rightContent":"MainLayout_rightContent__saBcX","contentArea":"MainLayout_contentArea__L30Z7"};